/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';

import { AIProactiveNudge as AIProactiveNudgeLegacy } from './ai-proactive-nudge-legacy';
import { AIProactiveNudge as AIProactiveNudgeMigrated } from './ai-proactive-nudge-migrated';

export const AIProactiveNudge = () =>
	fg('aix_nudge_recommendation_migration_enabled') ? (
		<AIProactiveNudgeMigrated />
	) : (
		<AIProactiveNudgeLegacy />
	);
